import { render, staticRenderFns } from "./DossierActivityDomainPanel.vue?vue&type=template&id=6c4331d2&scoped=true"
import script from "./DossierActivityDomainPanel.vue?vue&type=script&lang=ts"
export * from "./DossierActivityDomainPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4331d2",
  null
  
)

export default component.exports